<ng-container *ngFor="let filtro of filtrosMostrar">
    <span *ngIf="filtro.label; else notLabel"
        class="badge badge-dark badge-pointer"
    >{{filtro.label}}: {{filtro.value}}
        <i class='fas fa-times-circle hoverable' (click)="removeFilter(filtro)"></i>
    </span>
    <ng-template #notLabel>
        <span 
            class="badge badge-dark badge-pointer"
        >{{filtro.value}}
            <i class='fas fa-times-circle hoverable' (click)="removeFilter(filtro)"></i>
        </span>
    </ng-template>
    
</ng-container>

<span class="badge badge-warning badge-pointer" *ngIf="filtrosMostrar.length > 1">Quitar Filtros
    <i class='fas fa-times-circle hoverable' (click)="removeAll()"></i>
</span>